// extracted by mini-css-extract-plugin
export default {"melodyVideo":"UP-z","isFullWidth":"VP-z","landingPageVideo":"WP-z","play":"XP-z","iframeVideo":"YP-z","playHidden":"ZP-z","fullwidth":"_P-z"};